/* EILUNA product page: real variants and a real cart, 18 September 2026.
 *
 * The mockup product pages carry their own gallery, colour swatches and size pills, and
 * their own inline JavaScript that toggles those controls. NONE of it knew about Shopify:
 * the price was text, the size pills were decoration, and "Add to cart" did nothing.
 *
 * This does not replace that script and does not fight it. It OBSERVES the controls the
 * page already has and maps their state onto a real Shopify variant.
 *
 * WHY IT READS STATE AFTER A CLICK RATHER THAN HANDLING THE CLICK:
 * the page's own inline script sets aria-pressed, and two listeners on one element run in
 * registration order. This asset is deferred and the inline script is at the end of the
 * section, so that order is not something to rely on. Deferring the read to the next task
 * means this always sees the state the page settled on, whichever ran first.
 *
 * THE OPTION NAMES ARE NOT HARDCODED. The hoodie is Color x Size, the t-shirt is the same
 * with a third colour, and the poster is Size x Paper with one variant and no controls at
 * all. Matching is done by value against whatever options a variant actually carries, so a
 * page with no swatches and no pills simply falls through to the first available variant.
 */
(function () {
  var dataEl = document.getElementById('eilunaVariants');
  var form = document.getElementById('eilunaCartForm');
  var idInput = document.getElementById('eilunaVariantId');
  if (!dataEl || !form || !idInput) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent || '[]');
  } catch (e) {
    return;
  }
  if (!variants.length) return;

  function selectedColour() {
    var el = document.querySelector('.swatches .swatch[aria-pressed="true"]');
    if (!el) return null;
    // data-colour is lowercase in the markup; Shopify's option values are capitalised.
    var v = el.getAttribute('data-colour') || el.getAttribute('aria-label') || '';
    return v ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : null;
  }

  function selectedSize() {
    var el = document.querySelector('.sizes .pill[aria-pressed="true"]');
    return el ? (el.textContent || '').trim() : null;
  }

  function match() {
    var wanted = [selectedColour(), selectedSize()].filter(Boolean);
    if (!wanted.length) {
      // A page with no variant controls, such as the print. First available wins.
      for (var k = 0; k < variants.length; k++) {
        if (variants[k].available) return variants[k];
      }
      return variants[0];
    }
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      var hit = wanted.every(function (w) {
        return opts.some(function (o) {
          return String(o).toLowerCase() === String(w).toLowerCase();
        });
      });
      if (hit) return variants[i];
    }
    return null;
  }

  function money(pence) {
    // Shopify prices are in minor units. The page renders £85 rather than £85.00, which is
    // a design decision from the mockup, so whole amounts stay whole.
    var n = pence / 100;
    return '£' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }

  function sync() {
    var v = match();
    var adds = document.querySelectorAll('[data-eiluna-add], [data-eiluna-buy]');
    var i;

    if (!v) {
      for (i = 0; i < adds.length; i++) {
        adds[i].disabled = true;
        adds[i].setAttribute('aria-disabled', 'true');
      }
      return;
    }

    idInput.value = v.id;

    var prices = document.querySelectorAll('.price');
    for (i = 0; i < prices.length; i++) prices[i].textContent = money(v.price);

    for (i = 0; i < adds.length; i++) {
      adds[i].disabled = !v.available;
      adds[i].setAttribute('aria-disabled', String(!v.available));
      if (adds[i].hasAttribute('data-eiluna-add')) {
        adds[i].textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    }
  }

  // The page's own script owns the controls. This only reads what they settled on.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.swatches .swatch') || t.closest('.sizes .pill')) {
      setTimeout(sync, 0);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-eiluna-add], [data-eiluna-buy]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    sync();
    if (btn.hasAttribute('data-eiluna-buy')) {
      // Buy now: add, then go straight to checkout.
      var checkout = document.createElement('input');
      checkout.type = 'hidden';
      checkout.name = 'checkout';
      checkout.value = 'Checkout';
      form.appendChild(checkout);
    }
    form.submit();
  });

  sync();
})();
